export const MAX_ANNOTATION_LENGTH: number = 280;

export const testIds = {
  annotationView: 'annotation-view',
  annotationEdit: 'annotation-edit',
  btnEdit: 'btn-edit',
  textareaMessage: 'textarea-message',
};
